export default __webpack_public_path__ + "static/media/exploration.005162be.png";